export class SendAuctionACommand {
  private _procedureId: string
  private _userId: string
  private _batchesString: string

  constructor (procedureId: string, userId: string, batchesString: string) {
    this._procedureId = procedureId
    this._userId = userId
    this._batchesString = batchesString
  }

  procedureId (): string {
    return this._procedureId
  }

  userId (): string {
    return this._userId
  }

  concatenatedBatches (): string {
    return this._batchesString
  }
}
